export default __webpack_public_path__ + "static/media/news-btn-2.2d3a9bc8.jpg";